import * as React from 'react';
import './style.scss';
import IcRcln from '@magaele/ic_rcln';
import cx from 'classnames';

interface IMobileHeaderProps {
    title: string;
    leftIcon?: JSX.Element;
    onLeftIconClick?: () => void;
    rightIcon?: JSX.Element;
    onRightIconClick?: () => void;
}

const MobileHeader: React.FC<IMobileHeaderProps> = (props) => {
    const { title, leftIcon, onLeftIconClick, rightIcon, onRightIconClick } = props;
    return (
        <div className={cx('mobileHeader')}>
            <div className="leftIcon" onClick={onLeftIconClick}>
                {leftIcon}
            </div>
            <div className="title">{title}</div>
            <div className="rightIcon" onClick={onRightIconClick}>
                {rightIcon}
            </div>
        </div>
    );
};
MobileHeader.defaultProps = {
    leftIcon: (
        <IcRcln
            name="toolbefore"
            className="svg pink"
            style={{
                width: '30px',
                height: '45px',
                marginLeft: '13px',
                position: 'absolute',
                top: 0,
            }}
        />
    ),
};

export default MobileHeader;
